import React from "react";
import { Text, VStack } from "@chakra-ui/react";

const BlockUser = () => {
  return (
    <VStack
      align={"flex-start"}
      spacing={"6"}
      mb={"10"}
      w={{ base: "xs", md: "xl", lg: "8xl" }}
    >
      <Text>Хэрэглэгчийг хязгаарлах</Text>
    </VStack>
  );
};

export default BlockUser;
